import React from "react";
import PlaceholderLoadingForm from "../../components/PlaceholderLoadingForm";

export default function StudentPageLoading() {
  return <PlaceholderLoadingForm />;
}
